import { Switch } from "@mui/material";
import { renderEUDate } from "../../../utils/utils";
import { EditableInputDisplay } from "../../EditableComponents";

const getColumns = (setEditMode, setParentValue, { showDoctor = true } = {}) => {
  const columns = [
    {

      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      size: 150,
      header: "Nome",
      Cell: ({ cell, row }) =>
        row.original.row_type === "Recapiti" ? (
          <EditableInputDisplay
            label={null}
            id={"first_name"}
            setEditMode={setEditMode}
            initialValue={row.original.first_name}
            inputMode={"text"}
            setParentValue={setParentValue}
          />
        ) : (
          row.original.row_type
        ),
    },
    {
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      size: 120,
      header: "Cognome",
      Cell: ({ cell, row }) =>
        row.original.row_type === "Recapiti" ? (
          <EditableInputDisplay
            label={null}
            id={"last_name"}
            setEditMode={setEditMode}
            initialValue={row.original.last_name}
            inputMode={"text"}
            setParentValue={setParentValue}
          />
        ) : (
          ""
        ),
    },
    {
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      size: 100,
      header: "Data di Nascita",
      Cell: ({ cell, row }) =>
        row.original.row_type === "Recapiti" ? (
          <EditableInputDisplay
            label={null}
            id={"date_of_birth"}
            setEditMode={setEditMode}
            initialValue={row.original.date_of_birth}
            inputMode={"date"}
            setParentValue={setParentValue}
          />
        ) : (
          ""
        ),
    },
    {
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      size: 5,
      header: "Genere",
      Cell: ({ cell, row }) =>
        row.original.row_type === "Recapiti" ? (
          <EditableInputDisplay
            label={null}
            id={"gender"}
            setEditMode={setEditMode}
            initialValue={row.original.gender}
            inputMode={"text"}
            setParentValue={setParentValue}
          />
        ) : (
          ""
        ),
    },
    {
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      size: 150,
      header: "Codice Fiscale",
      Cell: ({ cell, row }) =>
        row.original.row_type === "Recapiti" ? (
          <EditableInputDisplay
            label={null}
            id={"cf"}
            setEditMode={setEditMode}
            initialValue={row.original.cf}
            inputMode={"text"}
            setParentValue={setParentValue}
          />
        ) : (
          ""
        ),
    },
  ];

  if (showDoctor) {
    columns.push({
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      size: 180,
      header: "Professionista Sanitario",
      Cell: ({ cell, row }) =>
        row.original.row_type === "Recapiti" ? (
          <EditableInputDisplay
            label={null}
            id={"doctor_id"}
            setEditMode={setEditMode}
            initialValue={row.original.doctor_id ?? 0}
            inputMode={"select"}
            selectType={"doctors"}
            selectQueryKey={["doctors"]}
            setParentValue={setParentValue}
          />
        ) : (
          ""
        ),
    });
  }

  return columns;
};

export default getColumns;
